import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap';
import { __AppElementType, enum__BOARD_TEMPLATE_TYPE } from '../../common/Dictionaries';
import BoardElementTypeBox from '../../components/Products/sKPI/Board/BoardElementTypeBox';
import { useGetConfigurableElements } from '../../hooks/services/sKPI/useOfBoard';
import BoardElementsConfigBox from '../../components/Products/sKPI/Board/BoardElementsConfigBox';
import Variable from '../Maintainers/sKPI/Variable';
import { useContext } from 'react';
import MainAppContext from '../../MainAppContext';
import { __OBJECT_STRUCTURE_GetList } from '../../common/ObjectStructures/Trasnversal';
import { useGetUserPropsKpi } from '../../hooks/services/sPrivilege/useOfPrivilege';
import BoardAppContext from '../../BoardAppContext';
import VariableNew from '../Maintainers/sKPI/Variable/indexNew';
import ProfileVerify from '../../components/Templates/Site/ProfileVerify';
import { useTranslation } from 'react-i18next';
import AuthVerify from '../../components/Templates/Site/AuthVerify';
import { useSelector } from 'react-redux';

function ElementConfiguration(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const { token: currentAuth } = useSelector((state) => state.auth);

    const [queryStringBoardId, setQueryStringBoardId] = useState(props.match.params.boardId !== null && props.match.params.boardId !== undefined && props.match.params.boardId !== "" ?
    props.match.params.boardId : null);

    const listElementTypes = __AppElementType

    const [elements, setElements] = useState(null)
    const [selectedVariables, setSelectedVariables] = useState(null)
    const [selectedElementTypeCard, setSelectedElementTypeCard] = useState({elementType: null, fireUpdate: false})
    
    const BoardType = enum__BOARD_TEMPLATE_TYPE.NONE

    const [userPropsKpi, setUserPropsKpi] = useState({hasAccess : null, onlyObserver: null})
    useGetUserPropsKpi(BoardType, null, null, contextSite.username, userPropsKpi, setUserPropsKpi)

    const boardContextStructure = {
        userPropsKpi: {
            value: userPropsKpi
        },
        boardElementList: {
            value: elements,
            set:  setElements,
        },
        selectedElement: {
            value: selectedElementTypeCard,
            set:  setSelectedElementTypeCard,
        }
    }

    useGetConfigurableElements(elements, setElements, selectedElementTypeCard, setSelectedElementTypeCard, (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin))

    const handleRowSelect = (selectedVariables) => {
        setSelectedVariables(selectedVariables);
    };

    return (<>

        <BoardAppContext.Provider value={ boardContextStructure }>
            <ProfileVerify />
            <Row>
                <Col xl={6}>
                    <Row>
                        <Col>             
                            <BoardElementTypeBox
                                inputParam_EditMode={ false }
                                inputParam_SetElements={ setElements }
                                inputParam_ElementList={ listElementTypes }
                                inputParam_CardElementNameIsDataLang={ true }
                                inputParam_BoardId={ parseInt(queryStringBoardId) }
                                inputParam_SetterSelectedElement={setSelectedElementTypeCard}
                                inputParam_ShowSelected={true}
                                inputParam_ShowFilters={false}
                                inputParam_CheckBoardId={false}
                                inputParam_EnableCollapse={false}
                            />
                        </Col>
                    </Row>
                    <Row className="py-1">
                        {
                            (contextSite.securityProps.isAdmin || contextSite.securityProps.isSAdmin) &&
                            <Col>
                                <Card>
                                    <VariableNew editMode={ false } inputParam_ShowButtons={false} inputParam_ShowSelection={ true } setterSetSelectedData={ handleRowSelect } />
                                </Card>
                            </Col>
                        }
                    </Row>
                </Col>
                <Col xl={6}>
                    {
                        elements &&
                        <BoardElementsConfigBox
                            inputParam_ElementType={ selectedElementTypeCard.elementType !== null ? selectedElementTypeCard.elementType.id : null }

                            inputParam_ElementListBase={ elements }
                            inputParam_SetElementsListBase={setElements}
                            
                            inputParam_EditMode={ true }
                            inputParam_BoardId={ queryStringBoardId }
                            inputParam_SelectedVariables={ selectedVariables }
                        />
                    }
                    {
                        !elements &&
                        <Card className='board-element-form h-100'>
                            <Card.Header className="card-header-compact">
                                <Card.Title className="d-flex justify-content-between">
                                    <b>{ t('data-lang-boxname-elements') }</b>
                                </Card.Title>
                            </Card.Header>
                            <Card.Body className="board-element-form-body pt-2 w-100">
                                <Row className='h-100'>
                                <Col className='text-center'>
                                    {t('data-lang-msg-selectbusinesselementtype')}
                                </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    }
                </Col>
            </Row>
        </BoardAppContext.Provider>
    </>);
}

export default ElementConfiguration;